import styled from 'styled-components';
import { DatatypeIcon } from '../datatype/DatatypeIcon.tsx';
import { type IReference } from './IReference.ts';

const DropdownMenuIconWrapper = styled.span`
  margin-right: 8px;
`;

export interface IExpressionReferenceIconProps {
  reference: IReference;
}
export function ExpressionReferenceIcon(props: IExpressionReferenceIconProps) {
  return (
    <DropdownMenuIconWrapper>
      {ExpressionReferenceIconOnly(props)}
    </DropdownMenuIconWrapper>
  );
}
export function ExpressionReferenceIconOnly(
  props: IExpressionReferenceIconProps,
) {
  return <DatatypeIcon type={props.reference.field.type} />;
}
